import React from "react";
// Commitment Contract page

// Default
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import moment from "moment";

// Mui
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid2";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";

// Custom
import Layout from "../../layout";
import CustomInput from "../../forms/input/Input";
import CustomSearch from "../search/Search";
import DatePickerInput from "../../forms/input/DatePickerInput";
import CustomOutlinedSelect from "../../forms/select/OutlinedCustomSelect";
import CustomToast from "../../components/toast/CustomToast";
import ContainedButton from "../../forms/button/ContainedButton";
import CustomChip from "../chip/Chip";
import CustomSearchBox from "../search/SearchBox";

// Utils
import { fetchGETRequest, fetchPOSTRequest } from "../../utils/services";
import { ToastState } from "../../types";

const CommitmentContract: React.FC = () => {
  const [searchValue, setSearchValue] = useState<{
    type: string;
    value: string;
  }>({
    type: "id",
    value: "",
  });
  const [toast, setToast] = useState<ToastState>({
    message: "",
    severity: "",
  });
  const [searchOpen, setSearchOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Contract Details");
  const [ruleBook, setRuleBook] = useState<
    {
      label: string;
      value: string;
    }[]
  >([
    {
      label: "TEST_RULE_BOOK2",
      value: "044cb970-133b-11ef-a093-1127a7ee82a3",
    },
    {
      label: "TEST_RULE_BOOK1",
      value: "348958b0-12bd-11ef-a093-1127a7ee82a3",
    },
    {
      label: "TEST_RULE_BOOK1",
      value: "64bcc530-12b8-11ef-a093-1127a7ee82a3",
    },
    {
      label: "TEST_RULE_BOOK1",
      value: "c3967710-12c5-11ef-a093-1127a7ee82a3",
    },
  ]);
  const [names, setNames] = useState<string[]>([]);
  const [filteredAssets, setFilteredAssets] = useState<any[]>([]);
  const [contractData, setContractData] = useState<{
    id: { id: string; entityType: string };
    consumerId: string;
    locationId: string;
    startDate: Date | null;
    endDate: Date | null;
    commodityType: {
      label: string;
      value: string;
    } | null;
    commodityCategory: {
      label: string;
      value: string;
    } | null;
    registerRuleBook: {
      label: string;
      value: string;
    } | null;
  }>({
    id: { id: "", entityType: "" },
    consumerId: "",
    locationId: "",
    startDate: null,
    endDate: null,
    commodityType: null,
    commodityCategory: null,
    registerRuleBook: {
      label: "",
      value: "",
    },
  });

  const [billingData, setBillingData] = useState<{
    fromDate: Date | null;
    toDate: Date | null;
    billingStatus: string | null;
  }>({
    fromDate: null,
    toDate: null,
    billingStatus: null,
  });
  const location = useLocation();

  const startDate = moment(contractData?.startDate);
  const today = moment();
  const isActive = startDate.isBefore(today);

  const navigate = useNavigate();
  const TABS = ["Contract Details", "Billing Determinants"];

  const determinantStatusOptions = [
    { value: "Initial", label: "Initial" },
    { value: "Success", label: "Success" },
    { value: "Rejected", label: "Rejected" },
  ];

  const commodityTypeOptions = [
    { value: "Electricity", label: "Electricity" },
    { value: "Water", label: "Water" },
    { value: "Gas", label: "Gas" },
  ];

  const commodityCategoryOptions = [
    { value: "Residential", label: "Residential" },
    { value: "Commercial", label: "Commercial" },
  ];

  const generateUniqueName = () => {
    const randomSuffix = Math.floor(Math.random() * 1000000000);
    const newName = `contract${randomSuffix}`;
    setNames([...names, newName]);
    return newName;
  };

  // useEffect(() => {
  //   const fetchAllPages = async () => {
  //     let page = 0;
  //     const pageSize = 10;
  //     let hasMoreData = true;
  //     const allData = [];

  //     try {

  //       while (hasMoreData) {

  //         const response = await fetchGETRequest(`tenant/assets?page=${page}&pageSize=${pageSize}`, {}, true)

  //         if (response?.status === 200) {
  //           const responseData = response?.data?.data;

  //           const filteredData = responseData?.filter(item =>
  //             item &&
  //             item.additionalInfo &&
  //             item.type === "registerRuleBook" &&
  //             item.additionalInfo.ruleBookCode !== null &&
  //             item.additionalInfo.ruleBookCode !== undefined
  //           );

  //           allData.push(...filteredData);

  //           hasMoreData = responseData.length === pageSize;
  //           page += 1;
  //         } else {
  //           hasMoreData = false;
  //         }
  //       }

  //       const updatedData = allData.map((item) => {
  //         return (
  //           { label: item?.additionalInfo?.ruleBookCode, value: item?.id?.id }
  //         )
  //       })

  //       setRuleBook(updatedData);
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   };

  //   fetchAllPages();
  // }, []);

  const handleSubmit = async () => {
    try {
      const requestData = {
        type: "CONTRACT",
        tenantId: {
          id: "e936e050-e1d7-11ee-8baa-37d11d926d57",
          entityType: "TENANT",
        },
        name: generateUniqueName(),
        label: "NY Building",
        additionalInfo: {
          consumerid: contractData.consumerId,
          locationId: contractData.locationId,
          startdate: contractData.startDate,
          enddate: contractData.endDate,
          commodityType: contractData.commodityType,
          commodityCategory: contractData.commodityCategory,
          registerRuleBook: contractData.registerRuleBook,
        },

        // ...(contractData.id && contractData.id.id && { id: { id: contractData.id.id, entityType: 'ASSET' } }),
      };

      if (contractData?.consumerId) {
        let secondResponse = null;
        const response = await fetchPOSTRequest(`asset`, requestData);

        if (response) {
          secondResponse = await fetchPOSTRequest(
            `customer/${contractData?.consumerId}/asset/${response?.id?.id}`,
            requestData,
            true
          );
        }

        setSearchValue({ ...searchValue, value: response?.id?.id });

        // setContractData({
        //   consumerId: "",
        //   locationId: "",
        //   startDate: null,
        //   endDate: null,
        //   commodityType: "",
        //   commodityCategory: "",
        //   registerRuleBook: "",
        // })

        // setLinkToCustomer("")

        if (secondResponse?.status === 200) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: response?.id?.id + " " + "Update successful!",
          });
        } else {
          setToast({
            message: response?.message,
            severity: "error",
          });
        }
      } else {
        setToast({
          message: "Consumer ID Field is Required",
          severity: "error",
        });
      }
    } catch (error: any) {
      console.error("Error saving data:", error.message);
    }
  };

  const handleContractSearch = async (payload?: string) => {
    try {
      let endpoint;
      if (searchValue?.value.trim()) {
        endpoint = searchValue?.value;
      } else if (payload) {
        endpoint = payload;
      } else {
        setToast({
          message: "Please enter a valid search value.",
          severity: "error",
        });
        return;
      }

      const response = await fetchGETRequest(`asset/${endpoint}`, {}, true);

      if (response?.data?.additionalInfo) {
        const {
          commodityCategory,
          commodityType,
          consumerid,
          enddate,
          registerRuleBook,
          locationId,
          startdate,
        } = response?.data?.additionalInfo;

        setContractData({
          id: response?.data?.id,
          consumerId: consumerid,
          locationId: locationId,
          startDate: new Date(startdate),
          endDate: new Date(enddate),
          commodityType:
            commodityTypeOptions.find((item) => item.value === commodityType) ||
            null,
          commodityCategory:
            commodityCategoryOptions.find(
              (item) => item.value === commodityCategory
            ) || null,
          registerRuleBook:
            ruleBook.find((item) => item.value === registerRuleBook) || null,
        });
      } else {
        setToast({ message: "Contract not found", severity: "error" });
      }
      setSearchOpen(false);
    } catch (error: any) {
      console.error("Error fetching consumer:", error.message);
      setSearchOpen(false);
    }
  };

  useEffect(() => {
    if (location?.state?.contractId) {
      setSearchValue({ ...searchValue, value: location?.state?.contractId });
      handleContractSearch(location?.state?.contractId);
    }
  }, [location]);

  const searchBillings = async () => {
    try {
      const allAssets = [];
      let page = 0;
      let hasMorePages = true;

      while (hasMorePages) {
        const response = await fetchGETRequest(
          `tenant/assets?page=${page}&pageSize=10`,
          {},
          true
        );

        if (response?.status === 200) {
          const assets = response?.data?.data;

          if (assets && Array.isArray(assets)) {
            allAssets.push(...assets);
            hasMorePages = assets.length > 0;
            page += 1;
          } else {
            hasMorePages = false;
          }
        } else {
          hasMorePages = false;
        }
      }

      const filteredAssets = allAssets.filter(
        (asset) =>
          asset.type === "billDeterminant" &&
          contractData.id.id === asset.additionalInfo.contractid &&
          new Date(asset.additionalInfo?.billPeriodFrom) >=
            new Date(billingData?.fromDate || "") &&
          new Date(asset.additionalInfo?.billPeriodTo) <=
            new Date(billingData?.toDate || "")
      );

      setFilteredAssets(filteredAssets);
    } catch (error: any) {
      console.error("Error fetching assets:", error.message);
    }
  };

  const handleGoToBillDeterminant = (billDeterminantId: string) => {
    navigate("/billing-determinant", { state: { billDeterminantId } });
  };

  const handleGoToConsumer = (consumerId: string) => {
    navigate("/consumer", {
      state: { consumerId: consumerId, contractId: contractData?.id?.id },
    });
  };

  const handleGoToSite = (locationId: string) => {
    navigate("/site", { state: { locationId: locationId } });
  };

  return (
    <Layout>
      <Card className="customer_title_card">
        <Typography variant="h5">Commitment Contract Information</Typography>
      </Card>

      <CustomToast
        open={toast?.message}
        severity={toast?.severity}
        setToast={setToast}
      />

      <Card
        className="customer_search_card"
        sx={{
          overflow: "visible",
          position: "relative",
        }}
      >
        <Typography variant="body1" fontWeight={600}>
          Commitment Contract ID
        </Typography>

        <Stack direction={"row"} gap={"10px"} alignItems={"center"}>
          <CustomSearchBox
            placeholder={"Enter 10 Digit"}
            width={"500px"}
            height={"40px"}
            handleSearchToggle={() => setSearchOpen(!searchOpen)}
            searchOpen={searchOpen}
            dialogBody={
              <Stack direction={"column"} gap={"20px"}>
                <CustomInput
                  label={"Type"}
                  value={searchValue?.type}
                  onChange={(e) =>
                    setSearchValue({
                      ...searchValue,
                      type: e.target.value,
                    })
                  }
                />
                <CustomInput
                  label={"Value"}
                  value={searchValue?.value}
                  onChange={(e) =>
                    setSearchValue({
                      ...searchValue,
                      value: e.target.value,
                    })
                  }
                />
                <ContainedButton
                  label={"Submit"}
                  sx={{
                    width: "100%",
                    fontWeight: 600,
                    color: "#ffffff",
                  }}
                  onClick={handleContractSearch}
                />
              </Stack>
            }
          />

          <ContainedButton
            label={"Save"}
            sx={{
              width: "fit-content",
              fontWeight: 600,
              height: "35px",
              color: "#ffffff",
            }}
            onClick={handleSubmit}
          />
        </Stack>
      </Card>

      <Card sx={{ mt: "20px" }}>
        <TabContext value={activeTab}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "#CACDD7",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <TabList
              onChange={(_, newValue) => setActiveTab(newValue)}
              scrollButtons={false}
              TabIndicatorProps={{
                style: {
                  backgroundColor: "##1280E7",
                  height: "3px",
                },
              }}
            >
              {TABS.map((item) => {
                return (
                  <Tab
                    label={
                      <Box
                        display="flex"
                        alignItems="center"
                        gap={"7px"}
                        fontWeight={500}
                      >
                        {item}
                      </Box>
                    }
                    value={item}
                    className="consumer_right_card_list_tab"
                  />
                );
              })}
            </TabList>
          </Box>

          <CardContent>
            <TabPanel value={TABS[0]} sx={{ padding: 0 }}>
              <Stack direction={"row"} gap={"5px"}>
                <Typography variant="body1">Status:</Typography>
                <CustomChip
                  label={isActive ? "Active " : "Inactive"}
                  sx={{
                    minWidth: "auto",
                  }}
                  backgroundColor={isActive ? "#9CE976" : "#FF3B30"}
                  color="#ffffff"
                />
              </Stack>

              <Grid container spacing={2} sx={{ mt: "10px" }}>
                <Grid size={{ xs: 12, md: 4, lg: 4 }} mt={"10px"}>
                  <Typography variant="body1" mb={"10px"}>
                    Consumer ID *
                  </Typography>
                  <CustomSearch
                    placeholder={"Enter 10 Digit"}
                    sx={{
                      width: "100%",
                      height: "40px",
                    }}
                    name={"consumerId"}
                    onChange={(e) => {
                      setContractData({
                        ...contractData,
                        consumerId: e.target.value,
                      });
                    }}
                    value={contractData?.consumerId}
                    onClick={() => handleGoToConsumer(contractData?.consumerId)}
                  />
                </Grid>

                <Grid size={{ xs: 12, md: 4, lg: 4 }} mt={"10px"}>
                  <Typography variant="body1" mb={"10px"}>
                    Location ID
                  </Typography>
                  <CustomSearch
                    placeholder={"Enter 10 Digit"}
                    sx={{
                      width: "100%",
                      height: "40px",
                    }}
                    name={"locationId"}
                    onChange={(e) => {
                      setContractData({
                        ...contractData,
                        locationId: e.target.value,
                      });
                    }}
                    value={contractData?.locationId}
                    onClick={() => handleGoToSite(contractData?.locationId)}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} mt={"20px"}>
                <Grid size={{ xs: 12, md: 4, lg: 4 }}>
                  <DatePickerInput
                    label={"Contract Start Date"}
                    placeholder={"dd/mm/yyyy hh:mm"}
                    name={"startDate"}
                    onChange={(event) => {
                      setContractData({
                        ...contractData,
                        startDate: event,
                      });
                    }}
                    value={contractData?.startDate}
                  />
                </Grid>
                <Grid size={{ xs: 12, md: 4, lg: 4 }}>
                  <DatePickerInput
                    label={"Contract End Date:"}
                    placeholder={"dd/mm/yyyy hh:mm"}
                    name={"endDate"}
                    onChange={(event) => {
                      setContractData({
                        ...contractData,
                        endDate: event,
                      });
                    }}
                    value={contractData?.endDate}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ mt: "20px" }}>
                <Grid size={{ xs: 12, md: 4, lg: 4 }} mt={"10px"}>
                  <CustomOutlinedSelect
                    label={"Commodity Type"}
                    options={commodityTypeOptions}
                    placeholder={"Select Commodity Type"}
                    name={"commodityType"}
                    onChange={(newValue) => {
                      setContractData({
                        ...contractData,
                        commodityType: newValue as {
                          label: string;
                          value: string;
                        },
                      });
                    }}
                    value={contractData.commodityType}
                  />
                </Grid>

                <Grid size={{ xs: 12, md: 4, lg: 4 }} mt={"10px"}>
                  <CustomOutlinedSelect
                    label={"Commodity Category"}
                    options={commodityCategoryOptions}
                    placeholder={"Select Commodity Category"}
                    name={"commodityCategory"}
                    onChange={(newValue) => {
                      setContractData({
                        ...contractData,
                        commodityCategory: newValue as {
                          label: string;
                          value: string;
                        },
                      });
                    }}
                    value={contractData.commodityCategory}
                  />
                </Grid>

                <Grid size={{ xs: 12, md: 4, lg: 4 }} mt={"10px"}>
                  <CustomOutlinedSelect
                    label={"Register Rule Book"}
                    options={ruleBook}
                    placeholder={"Select"}
                    name={"registerRuleBook"}
                    onChange={(newValue) => {
                      setContractData({
                        ...contractData,
                        registerRuleBook: {
                          label: newValue.label,
                          value: newValue.value as string,
                        },
                      });
                    }}
                    value={contractData?.registerRuleBook}
                  />
                </Grid>
              </Grid>
            </TabPanel>

            <TabPanel value={TABS[1]} sx={{ padding: 0 }}>
              <Stack
                direction={"row"}
                justifyContent={"flex-end"}
                alignItems={"center"}
              >
                <ContainedButton
                  label={"Add Billing Determinant"}
                  sx={{
                    width: "fit-content",
                    fontWeight: 600,
                    color: "#ffffff",
                  }}
                  onClick={() => navigate("/billing-determinant")}
                />
              </Stack>

              <Grid container spacing={2} mt={"20px"}>
                <Grid size={{ xs: 12, md: 4, lg: 4 }}>
                  <DatePickerInput
                    label={"From Date:"}
                    placeholder={"dd/mm/yyyy hh:mm"}
                    name={"fromDate"}
                    value={billingData?.fromDate}
                    onChange={(newValue) => {
                      setBillingData({
                        ...billingData,
                        fromDate: newValue,
                      });
                    }}
                  />
                </Grid>
                <Grid size={{ xs: 12, md: 4, lg: 4 }}>
                  <DatePickerInput
                    label={"To Date:"}
                    placeholder={"dd/mm/yyyy hh:mm"}
                    name={"toDate"}
                    value={billingData?.toDate}
                    onChange={(newValue) => {
                      setBillingData({
                        ...billingData,
                        toDate: newValue,
                      });
                    }}
                  />
                </Grid>
                <Grid size={{ xs: 12, md: 4, lg: 4 }}>
                  <CustomOutlinedSelect
                    placeholder={"Status"}
                    options={determinantStatusOptions}
                    name={"billingStatus"}
                    value={
                      billingData?.billingStatus
                        ? {
                            label: billingData?.billingStatus,
                            value: billingData?.billingStatus,
                          }
                        : null
                    }
                    label={"Billing Determinant Status"}
                    onChange={(newValue) => {
                      setBillingData({
                        ...billingData,
                        billingStatus: newValue.value as string,
                      });
                    }}
                  />
                </Grid>
              </Grid>

              <ContainedButton
                label={"Search"}
                sx={{
                  width: "fit-content",
                  fontWeight: 600,
                  mt: "20px",
                  color: "#ffffff",
                }}
                onClick={searchBillings}
              />

              <Grid container spacing={2} mt={"20px"}>
                {filteredAssets
                  .filter(
                    (asset) =>
                      asset.additionalInfo?.contractid === contractData?.id?.id
                  )
                  .map((item) => {
                    return (
                      <Grid size={{ xs: 12, md: 4, lg: 4 }}>
                        <Box
                          sx={{
                            background: "#e3f1fa",
                            mt: "20px",
                            padding: "15px",
                            borderRadius: "6px",
                          }}
                        >
                          <Stack
                            direction={"row"}
                            justifyContent={"space-between"}
                            alignItems={"center"}
                          >
                            <Typography
                              variant="body1"
                              fontWeight={"400"}
                              fontSize={"13px"}
                            >
                              Bill Determinant ID:
                            </Typography>
                            <Typography variant="body2" fontWeight={"600"}>
                              {item?.id?.id}
                            </Typography>
                          </Stack>

                          <Typography
                            variant="body1"
                            mt={"5px"}
                            fontSize={"13px"}
                            fontWeight={"400"}
                          >
                            {" "}
                            From: {item?.additionalInfo?.billPeriodFrom}
                          </Typography>
                          <Typography
                            variant="body1"
                            mt={"5px"}
                            fontSize={"13px"}
                            fontWeight={"400"}
                          >
                            {" "}
                            To: {item?.additionalInfo?.billPeriodTo}
                          </Typography>

                          <Stack direction={"row"} justifyContent={"flex-end"}>
                            <ContainedButton
                              label={"Go To Bill Determinant"}
                              sx={{
                                width: "fit-content",
                                fontWeight: 600,
                                mt: "10px",
                                color: "#ffffff",
                              }}
                              onClick={() =>
                                handleGoToBillDeterminant(item?.id?.id)
                              }
                            />
                          </Stack>
                        </Box>
                      </Grid>
                    );
                  })}
              </Grid>
            </TabPanel>

            {/* <Stack direction={"direction"} justifyContent={"space-between"} justifyItems={"center"} mt={"20px"}>

              <ContainedButton
                label={"Go to Consumer"}
                
                sx={{
                  width: "fit-content",
                  fontWeight: 600,
                  height: "35px",
                  color: "#ffffff",
                }}
                onClick={() => handleGoToConsumer(contractData?.consumerId)}
              />

              <ContainedButton
                label={"Go to Site"}
                
                sx={{
                  width: "fit-content",
                  fontWeight: 600,
                  height: "35px",
                  color: "#ffffff",
                }}
                onClick={()=> handleGoToSite(contractData?.locationId)}
              />

            </Stack> */}
          </CardContent>
        </TabContext>
      </Card>
    </Layout>
  );
};

export default CommitmentContract;
